import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeneralCalculationsService {

  constructor() { }

    /**
   * Get the total days between two given dates (startDate and endDate)
   * @param startDate 
   * @param endDate 
   * @returns days
   */
    getTotalDaysBetween2Days(startDate: Date, endDate: Date) {

      let days = 0;
      startDate = new Date(startDate.setHours(0,0,0,0));
      endDate = new Date(endDate.setHours(0,0,0,0));
  
      //calculate difference days between two days
      if (endDate != null && startDate != null) {
        days = Math.round((endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000));
      } else {
        days = 0;
      }
      return days + 1; //+1 because we need the total days
    }

    /**
     * Method to count how many accesses in the last week
     * @param accesses Array of JSON objects
     */
    countHowManyAccessesLastWeek(accesses: any ){

      const getDayName = (date: Date) => date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

      // Get last seven days with YYYY-MM-DD format
      const today = new Date();
      const days = [];
      for (let i = 6; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(today.getDate() - i);
        days.push(d.toISOString().split('T')[0]);
      }

      // Count accesses
      const accessCountByDate = days.reduce((acc: any, date: any) => {
        acc[date] = { accesses: 0, totalDuration: 0 };
        return acc;
      }, {});

      accesses.forEach((entry: any) => {
        const entryDate = new Date(entry.date).toISOString().split('T')[0];
        if (entryDate in accessCountByDate) {
          accessCountByDate[entryDate].accesses++;
          accessCountByDate[entryDate].totalDuration += entry.sessionDurationInSeconds;
        }
      });

      // Add day of week in English
      const chartData = days.map(date => {
        const dayName = getDayName(new Date(date));
        return {
          date,
          accesses: accessCountByDate[date].accesses,
          day: dayName,
          totalDuration: ((accessCountByDate[date].totalDuration)/60).toFixed(2) // Add total session duration
        };
      });

      return chartData;

    }

  /**
   * Method to calculate when the questionnaires are opened and closed 
   * @param baselineQuestionnaireStart (in UTC)
   */
  calculateQuestionnaireDates(baselineQuestionnaireStart : any){


    let baselineCutOffDate = new Date(2026, 10, 30, 23, 59, 59, 999); // Nov 30, 2026
    let midCutOffDate = new Date(2027, 1, 28, 23, 59, 59, 999);     // Feb 28, 2027
    let endCutOffDate = new Date(2028, 1, 29, 23, 59, 59, 999);   // Feb 29, 2028

    let maxMidQuestionnaireStartDate = new Date(2027, 0, 1);   // Jan 1, 2027
    let maxFinalQuestionnaireStartDate = new Date(2028, 0, 1);   // Jan 1, 2028

    let baseline = new Date(baselineQuestionnaireStart);

    //v1
    let baselineQuestionnaireClose =  new Date(baseline);
    let baselineQuestionnaireCloseExtended =  new Date(baseline);
    let baselineQuestionnaireCloseExtendedExists = false;
    baselineQuestionnaireClose.setUTCDate(baseline.getUTCDate() + 30);

    //Establish the cut-off date for the baseline questionnaire
    if (baselineQuestionnaireClose > baselineCutOffDate) {
      baselineQuestionnaireClose = baselineCutOffDate;
    }

    //v6
    let midQuestionnaire = new Date(baseline);
    midQuestionnaire.setUTCMonth(baseline.getUTCMonth() + 6);

    let midQuestionnaireCloseExtended =  new Date(baseline);
    let midQuestionnaireCloseExtendedExists = false;

    let midQuestionnaireStart = new Date(midQuestionnaire);
    midQuestionnaireStart.setUTCDate(midQuestionnaire.getUTCDate() - 30);
    let midQuestionnaireClose = new Date(midQuestionnaire);
    midQuestionnaireClose.setUTCDate(midQuestionnaire.getUTCDate() + 30);

    //Establish the early starting date for the mid questionnaire
    if (midQuestionnaireStart > maxMidQuestionnaireStartDate) {
      midQuestionnaireStart = maxMidQuestionnaireStartDate;
    }

    //Establish the cut-off date for the mid questionnaire
    if (midQuestionnaireClose > midCutOffDate) {
      midQuestionnaireClose = midCutOffDate;
    }

    //Establish the extension for the baseline questionnaire (from recommended close to next questionnaire start)
    if(baselineQuestionnaireClose < midQuestionnaireStart && baselineQuestionnaireClose!=baselineCutOffDate){
      if(midQuestionnaireStart < baselineCutOffDate){
        baselineQuestionnaireCloseExtended = midQuestionnaireStart;
      }else{
        baselineQuestionnaireCloseExtended = baselineCutOffDate;
      }
      baselineQuestionnaireCloseExtendedExists = true;
    }

    //V18
    let finalQuestionnaire = new Date(baseline);

    let finalQuestionnaireCloseExtended =  new Date(baseline);
    let finalQuestionnaireCloseExtendedExists = false;

    finalQuestionnaire.setUTCMonth(baseline.getUTCMonth() + 18);
    let finalQuestionnaireStart = new Date(finalQuestionnaire);
    finalQuestionnaireStart.setUTCDate(finalQuestionnaire.getUTCDate() - 30);
    let finalQuestionnaireClose = new Date(finalQuestionnaire);
    finalQuestionnaireClose.setUTCDate(finalQuestionnaire.getUTCDate() + 30);


    //Establish the early starting date for the final starting questionnaire
    if (finalQuestionnaireStart > maxFinalQuestionnaireStartDate) {
      finalQuestionnaireStart = maxFinalQuestionnaireStartDate;
    }

    //Establish the cut-off date for the final questionnaire
    if (finalQuestionnaireClose > endCutOffDate) {
      finalQuestionnaireClose = endCutOffDate;
    }

    //Establish the extension for the mid questionnaire (from recommended close to next questionnaire start)
    if(midQuestionnaireClose < finalQuestionnaireStart && midQuestionnaireClose!=midCutOffDate){
      if(finalQuestionnaireStart < midCutOffDate){
        midQuestionnaireCloseExtended = finalQuestionnaireStart;
      }else{
        midQuestionnaireCloseExtended = midCutOffDate;
      }
      midQuestionnaireCloseExtendedExists = true;
    }

    //Establish the extension for the final questionnaire (from recommended close to the end)
    if(finalQuestionnaireClose < endCutOffDate){
      finalQuestionnaireCloseExtended = endCutOffDate;
      finalQuestionnaireCloseExtendedExists = true;
    }


    let questionnairesDate = {
      'startBaselineQuestionnaire' : baseline.toISOString(),
      'endBaselineQuestionnaire' : baselineQuestionnaireClose.toISOString(),
      'baselineQuestionnaireCloseExtendedExists': baselineQuestionnaireCloseExtendedExists,
      'baselineQuestionnaireCloseExtended' : baselineQuestionnaireCloseExtended.toISOString(),
      'startMidQuestionnaire' : midQuestionnaireStart.toISOString(),
      'endMidQuestionnaire' : midQuestionnaireClose.toISOString(),
      'midQuestionnaireCloseExtendedExists': midQuestionnaireCloseExtendedExists,
      'midQuestionnaireCloseExtended' : midQuestionnaireCloseExtended.toISOString(),
      'startFinalQuestionnaire' : finalQuestionnaireStart.toISOString(),
      'endFinalQuestionnaire' : finalQuestionnaireClose.toISOString(),
      'finalQuestionnaireCloseExtendedExists': finalQuestionnaireCloseExtendedExists,
      'finalQuestionnaireCloseExtended' : finalQuestionnaireCloseExtended.toISOString(),
    }

    return questionnairesDate;

  }
}
